import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import { Select } from 'antd';
// Local deps
import './Select.scss';

const Option = Select.Option;

class SelectField extends React.Component {
  render() {
    const {
      //   errorCol,
      //   isRequired,
      // ...otherProps,
      options,
    } = this.props;
    return (
      <div>
        <Row>
          {/* <!-- INPUT --> */}
          <Col xs="3">
            <Select
              onChange={this._OnChange}
              defaultValue="pending"
              width={120}
            >
              {options.map(option => (
                <Option value={option.value} key={option.value}>
                  {option.text}
                </Option>
              ))}
            </Select>
          </Col>
          {/* <!-- ERROR -> */}
        </Row>
      </div>
    );
  }
}

SelectField.defaultProps = {
  //   label: '',
  //   isRequired: false,
};

SelectField.propTypes = {
  //   label: PropTypes.string,
  //   isRequired: PropTypes.bool,
  options: PropTypes.array.isRequired,
};

export default SelectField;



// WEBPACK FOOTER //
// ./src/components/Select/Select.jsx